import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import JunoButton from '../../../new-ui/components/common/JunoButton.jsx'

const FrozenWalletCard = ({ title = "BTC WALLET FROZEN", description, onContactSupport = null }) => {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    return (
        <div className="md:h-full">
            <div className="relative xxs:h-[140px] xxs:px-3 lg:!p-6 xxs:py-4 md:h-full bg-[#ffffff] !bg-opacity-[0.3]  dark:!bg-[#26272B] dark:!bg-opacity-[0.3] rounded-lg outline outline-1 outline-offset-[-1px] outline-black/10 overflow-hidden flex flex-col justify-between">
                <div className="flex xxs:flex-row-reverse lg:flex-col items-center xxs:items-start  lg:!gap-[5rem] w-full">
                    <div className="w-auto sm:w-[56px] lg:w-full flex justify-center sm:justify-end lg:justify-center ">
                        <img
                            src={`${imageBaseUrl}/common/frozen-icon.png`}
                            className="xxs:w-8 xxs:h-8 lg:w-10 lg:h-10 w-auto shrink-0"
                            alt="Frozen icon"
                        />
                    </div>
                    <div className="flex-1 flex flex-col text-center  xxs:!text-left lg:text-center xxs:gap-1">
                        <h2 className="!text-text font-[Inter] font-semibold text-sm leading-5 tracking-normal uppercase">
                            {title}
                        </h2>
                        <p className="text-gray-custom font-[Inter] font-medium text-xs leading-4 tracking-normal uppercase">
                            {description || "This wallet has been frozen, for assistance."}
                        </p>
                    </div>
                </div>
                <JunoButton
                    onClick={onContactSupport}
                    className="!bg-text !px-[9px] !py-[6px] xxs:mt-4 lg:mt-2 rounded-md font-[Inter] text-xs leading-[26px] tracking-[0.02em] xxs:font-bold lg:font-semibold uppercase !w-fit xxs:!h-[1.75rem] lg:!h-[1.50rem]  sm:self-start flex items-center justify-center "
                >
                    contact support
                </JunoButton>

            </div>
        </div>
    );
};

FrozenWalletCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    onContactSupport: PropTypes.func.isRequired,
};

export default FrozenWalletCard;
